import { useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../components/navbar/navbar.jsx'
import './pedido-editar.css'
import { v4 as uuidv4 } from 'uuid'
import { useEffect } from 'react'
import moment from 'moment'
import AutocompleteProdutoMatch from '../../components/auto-complete-match-produto/complete-match.jsx'

function PedidoEditar() {
  const { id_pedido } = useParams()
  const navigate = useNavigate()

  const [id_cliente, setIdCliente] = useState(0)
  const [dt_pedido, setDtPedido] = useState('')
  const [id_cond_pagto, setIdCondPagto] = useState(0)
  const [dt_entrega, setDtEntrega] = useState('')
  const [obs, setObs] = useState('')
  const [produtos, setProdutos] = useState([])
  const [vl_total, setVlTotal] = useState(0)
  const [msg, setMsg] = useState('')

  const [lista_produtos, setListaProdutos] = useState([])
  const [lista_clientes, setListaClientes] = useState([])
  const [cond_pagtos, setCondPagtos] = useState([])

  function AdicionarProduto() {
    const prod = {
      id_item: uuidv4(),
      id_produto: 0,
      descricao: '',
      qtd: 1,
      vl_unit: 0,
      vl_total: 0,
    }

    setProdutos([...produtos, prod])
    console.log(produtos)
  }

  function ExcluirProduto(id_item) {
    const prod = []

    produtos.map((p) => {
      if (p.id_item != id_item) {
        prod.push(p)
        console.log(p)
      }
    })

    setProdutos(prod)
  }

  function CarregarDadosPedido(id_ped) {
    // Editar..
    if (id_ped > 0) {
      setIdCliente(1)
      setDtPedido('2023-10-10')
      setIdCondPagto(2)
      setDtEntrega('2023-10-30')
      setObs('Teste')
      setProdutos([
        {
          id_item: 1,
          id_produto: 1,
          descricao: 'MONITOR DELL',
          qtd: 2,
          vl_unit: 510,
          vl_total: 1020,
        },
        {
          id_item: 2,
          id_produto: 2,
          descricao: 'HD SEAGATE 2TB',
          qtd: 1,
          vl_unit: 300,
          vl_total: 300,
        },
      ])
    }
    // Inserir...
    else {
      setIdCliente(0)
      setDtPedido(moment().format('YYYY-MM-DD'))
      setIdCondPagto(0)
      setDtEntrega(moment().format('YYYY-MM-DD'))
      setObs('')
      setProdutos([])
    }
  }

  function PesquisarClientes() {
    // Fazer um GET no servidor...
    setListaClientes([
      { id_cliente: 1, nome: '99 Coders' },
      { id_cliente: 2, nome: 'Mercado Central' },
    ])
  }

  function PesquisarProdutos() {
    // Fazer um GET no servidor...
    setListaProdutos([
      { id_item: 1, id_produto: 1, descricao: 'MONITOR DELL' },
      { id_item: 2, id_produto: 2, descricao: 'HD SEAGATE 2TB' },
      { id_item: 3, id_produto: 3, descricao: 'MOUSE LOGITECH' },
    ])
  }

  function PesquisarCondPagtos() {
    // Fazer um GET no servidor...
    setCondPagtos([
      { id_cond_pagto: 1, cond_pagto: '30 Dias' },
      { id_cond_pagto: 2, cond_pagto: '45 Dias' },
    ])
  }

  function handleDescricaoChange(id_produto, descricao, index) {
    const prod = [...produtos]

    prod[index].id_produto = id_produto
    prod[index].descricao = descricao

    setProdutos(prod)
  }

  function handleQtdChange(qtd, index) {
    const prod = [...produtos]

    prod[index].qtd = qtd
    prod[index].vl_total = qtd * prod[index].vl_unit

    setProdutos(prod)
  }

  function handleVlUnitChange(vl, index) {
    const prod = [...produtos]

    prod[index].vl_unit = vl
    prod[index].vl_total = prod[index].qtd * vl

    setProdutos(prod)
  }

  function CalculaTotal() {
    let total = 0

    produtos.map((prod) => {
      total = total + prod.vl_total
    })

    setVlTotal(total)
  }

  function SalvarDados() {
    const dados_pedido = {
      id_cliente: id_cliente,
      id_cond_pagto,
      id_usuario: 0,
      dt_pedido,
      dt_entrega,
      vl_total,
      itens: produtos,
    }

    // Fazer um POST / PUT para o server...

    navigate('/pedidos')
  }

  useEffect(() => {
    PesquisarClientes()
    PesquisarProdutos()
    PesquisarCondPagtos()
    CarregarDadosPedido(id_pedido)
  }, [])

  useEffect(() => {
    CalculaTotal()
  }, [produtos])

  return (
    <>
      <Navbar />

      <div className="container-fluid mt-page form-pedido-editar">
        <div className="row col-lg-6 offset-lg-3">
          <div className="col-12 mb-4 mt-2">
            <h2 className="d-inline">
              {id_pedido > 0 ? 'Editar Pedido ' + id_pedido : 'Novo Pedido'}
            </h2>
          </div>

          <div className="col-md-8 mb-4">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Cliente
            </label>
            <div className="form-control mb-2">
              <select
                name="clientes"
                id="clientes"
                onChange={(e) => setIdCliente(e.target.value)}
                value={id_cliente}
              >
                <option value="0">Selecione um cliente</option>
                {lista_clientes.map((c) => {
                  return (
                    <option
                      key={c.id_cliente}
                      value={c.id_cliente}
                    >
                      {c.nome}
                    </option>
                  )
                })}
              </select>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <label
              htmlFor="InputEmail"
              className="form-label"
            >
              Data Venda
            </label>
            <input
              type="date"
              onChange={(e) => setDtPedido(e.target.value)}
              value={dt_pedido}
               className="form-control form-control-sm"
              id="InputEmail"
              aria-describedby="email"
            />
          </div>

          <div className="col-md-8 mb-4">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Cond. Pagamento
            </label>
            <div className="form-control mb-2">
              <select
                name="cond_pagto"
                id="cond_pagto"
                onChange={(e) => setIdCondPagto(e.target.value)}
                value={id_cond_pagto}
              >
                <option value="0">Selecione a cond. pagto</option>

                {cond_pagtos.map((c) => {
                  return (
                    <option
                      key={c.id_cond_pagto}
                      value={c.id_cond_pagto}
                    >
                      {c.cond_pagto}
                    </option>
                  )
                })}
              </select>
            </div>
          </div>

          <div className="col-md-4 mb-5">
            <label
              htmlFor="InputEmail"
              className="form-label"
            >
              Previsão Entrega
            </label>
            <input
              type="date"
              onChange={(e) => setDtEntrega(e.target.value)}
              value={dt_entrega}
               className="form-control form-control-sm"
              id="InputEmail"
              aria-describedby="email"
            />
          </div>


          <div>
            {/* Adicione um botão ou chave de alternância para trocar entre o modo de busca e entrada manual */}
            <button
              type="button"
              onClick={alternarModoBusca}
              className="botao-estilizado mb-3"
            >
              {/* Adicione o ícone do Bootstrap ao botão com o texto */}
              {estaBuscando ? (
                <>
                  <i className="bi bi-search"></i> Buscar
                </>
              ) : (
                <>
                  <i className="bi bi-pencil"></i> Inserção Manual
                </>
              )}
            </button>

            <div className="table-responsive">
              <div className="col-12">
                <table className="table table-striped table-bordered ">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="w-30 text-dark"
                      >
                        Sku
                      </th>
                      <th
                        scope="col"
                        className="w-50 text-dark"
                      >
                        Produto
                      </th>
                      <th
                        scope="col"
                        className="w-10 text-dark"
                      >
                        Qtd
                      </th>
                      <th
                        scope="col"
                        className="w-20 text-dark"
                      >
                        Valor Unit.
                      </th>
                      <th
                        scope="col"
                        className="w-20 text-dark"
                      >
                        Desconto
                      </th>
                      <th
                        scope="col"
                        className="w-20 text-dark"
                      >
                        Valor Total
                      </th>
                      <th
                        scope="col"
                        className="w-20 text-dark"
                      >
                        Obs
                      </th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {produtos.map((produto, index) => (
                      <tr key={produto.id}>
                        <td>
                          <input
                            type="text"
                            value={produto.codigo}
                            className="form-control w-30"
                          />
                        </td>
                        <td>
                          {/* Renderize o campo de descrição baseado em `estaBuscando` */}
                          {estaBuscando ? (
                            <AutocompleteProdutoMatch
                              placeholder="Produto banco..."
                              onClickId={(id) =>
                                handleProdutoIdChange(id, index)
                              }
                              onClickNome={(nome) =>
                                handleProdutoNomeChange(nome, index)
                              }
                              onClickProdInterno={(prodInterno) =>
                                handleProdutoInternoChange(prodInterno, index)
                              }
                              OnClickValor={(vlr) =>
                                handleVlUnitChange(vlr, index)
                              }
                              ClickTexto={handleTextoChange} // Função para lidar com o texto digitado
                              value={produto.descricao}
                               className="form-control form-control-sm"
                            />
                          ) : (
                            <input
                              type="text"
                              value={produto.descricao}
                              onChange={(e) =>
                                handleProdutoNomeChangeInput(
                                  e.target.value,
                                  index,
                                )
                              }
                               className="form-control form-control-sm"
                            />
                          )}
                        </td>
                        <td>
                          <input
                            type="text"
                            onChange={(e) =>
                              handleQtdChange(
                                e.target.value.replace(',', '.'),
                                index,
                              )
                            }
                            value={
                              produto.quantidade !== undefined
                                ? produto.quantidade
                                  .toString()
                                  .replace('.', ',')
                                : ''
                            }
                            className="form-control w-100"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onChange={(e) =>
                              handleVlUnitChange(e.target.value, index)
                            }
                            value={
                              produto.valorunitario !== undefined
                                ? produto.valorunitario.toLocaleString(
                                  undefined,
                                  { minimumFractionDigits: 2 },
                                )
                                : ''
                            }
                            className="form-control w-100"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={formatValue(produto.desconto)}
                            className="form-control w-100"
                            onChange={(e) =>
                              handleDescontoChange(e.target.value, index)
                            }
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            value={
                              produto.valor_total_item !== undefined
                                ? produto.valor_total_item.toLocaleString(
                                  undefined,
                                  { minimumFractionDigits: 2 },
                                )
                                : ''
                            }
                            className="form-control w-100"
                            disabled
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            value={produto.obs}
                            className="form-control w-100"
                            onChange={(e) =>
                              handleObsChange(e.target.value, index)
                            }
                          />
                        </td>

                        <td>
                          <button
                            type="button"
                            onClick={(e) => ExcluirProduto(produto.id)}
                            className="btn btn-danger"
                          >
                            <i className="bi bi-trash3-fill"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {produtos.length === 0 && (
                  <div className="no-item">Nenhum produto cadastrado</div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={AdicionarProduto}
            >
              Adicionar Produto
            </button>
          </div>

          <div className="col-md-6 text-end mb-5">
            <span className="me-4">Total Pedido:</span>
            <b>
              {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              }).format(vl_total)}
            </b>
          </div>

          <div className="col-12">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Obs
            </label>
            <textarea
              type="text"
              onChange={(e) => setObs(e.target.text)}
              value={obs}
               className="form-control form-control-sm"
            />
          </div>

          <div className="col-12 mt-3">
            {msg.length > 0 ? (
              <div className="alert alert-danger mt-4 text-center">{msg}</div>
            ) : null}
            <div>
              <div className="d-flex justify-content-end">
                <Link
                  to="/pedidos"
                  type="button"
                  className="btn btn-outline-primary me-4"
                >
                  Cancelar
                </Link>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={SalvarDados}
                >
                  Salvar Dados
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PedidoEditar
